function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Compare = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsxs(SvgIcon, _extends({
    "data-testid": "CompareIcon"
  }, props, {
    ref: ref,
    children: [/*#__PURE__*/_jsx("g", {
      opacity: ".8",
      children: /*#__PURE__*/_jsx("path", {
        d: "M11.078 16.403 9.18 14.545a.984.984 0 0 1 0-1.412 1.035 1.035 0 0 1 1.442 0L15 17.422l-4.377 4.287c-.399.39-1.044.39-1.442 0a.984.984 0 0 1 0-1.412l1.897-1.858H5.314a2.038 2.038 0 0 1-2.034-1.883l-.005-.152V10h2.039v6.403h5.764zM12.922 7.597l1.897 1.858a.984.984 0 0 1 0 1.412c-.398.39-1.043.39-1.442 0L9 6.579l4.377-4.287a1.035 1.035 0 0 1 1.442 0 .984.984 0 0 1 0 1.412l-1.897 1.858h5.764c1.075 0 1.956.83 2.034 1.883l.006.152V14h-2.04V7.597h-5.764z"
      })
    }), /*#__PURE__*/_jsx("path", {
      d: "M1 5a1 1 0 0 1 1-1h4.5a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5zM23 19a1 1 0 0 1-1 1h-4.5a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1H22a1 1 0 0 1 1 1v4z"
    })]
  }));
});
Compare.displayName = 'CompareIcon';
export default Compare;